import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '../../utils/cn';

const Button = React.forwardRef((
  {
    className,
    variant = 'primary',
    size = 'default',
    asChild = false,
    children,
    ...props
  },
  ref
) => {
  const baseClasses = 'inline-flex items-center justify-center rounded-lg font-medium transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-global-green focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50';
  
  const variants = {
    primary: 'bg-global-green text-white hover:bg-global-dark-blue shadow-lg hover:shadow-xl',
    secondary: 'bg-white text-global-dark-blue hover:bg-global-light-blue hover:text-white border border-global-green',
    outline: 'border border-global-green text-global-green hover:bg-global-green hover:text-white',
    ghost: 'text-global-green hover:bg-global-light-blue hover:text-white',
    destructive: 'bg-red-600 text-white hover:bg-red-700',
  };
  
  const sizes = {
    sm: 'h-9 px-3 text-sm',
    default: 'h-11 px-6 py-2',
    lg: 'h-12 px-8 text-lg',
    xl: 'h-14 px-10 text-xl',
  };

  const Component = asChild ? motion.div : motion.button;

  return (
    <Component
      className={cn(baseClasses, variants[variant], sizes[size], className)}
      ref={ref}
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      {...props}
    >
      {children}
    </Component>
  );
});

Button.displayName = 'Button';

export default Button;
export { Button };